import { INDUSTRIES, IMAGES } from "../data/content";
import { SectionHeader, CTABand } from "./Home";

export default function IndustriesPage() {
  return (
    <div data-testid="industries-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
          <SectionHeader
            eyebrow="Industries We Serve"
            title="One methodology, tuned to your standards."
            sub="A lender's collateral file, a lawyer's opinion, a developer's board pack, and a family's first home all rely on the same thing — records verified at the source. We deliver them in the format each audience demands."
          />
          <img src={IMAGES.industries} alt="Modern lattice building" className="w-full h-[420px] object-cover" />
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#F9FAFA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((i) => (
            <div key={i.title} data-testid={`industry-card-${i.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="tt-card p-10">
              <i.icon size={32} strokeWidth={1} className="text-[#C1A74A]" />
              <h2 className="font-heading text-xl font-medium text-[#113835] mt-6">{i.title}</h2>
              <p className="mt-4 text-sm text-gray-600 font-light leading-relaxed">{i.text}</p>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
